import { useAuthStore } from '@/store/auth'

export const useDualAsyncData = (async (...args) => {
  const authStore = useAuthStore()

  const nuxtApp = useNuxtApp()

  // @ts-expect-error: 有 "A spread argument must either have a tuple type or be passed to a rest parameter." type error，看起來是 TS 判斷問題，先忽略。
  const asyncData = await useAsyncData(...args)
  const { refresh } = asyncData

  const refetchDataIfLogin = () => {
    /**
     * 因這個 composable 只希望在 server side 和 client side 各觸發一次 api，
     * 需要排除在 client side 觸發兩次 api 的狀況 (useAsyncData 是在 client side 觸發)。
     *
     * 使用 nuxtApp.isHydrating 來判斷是否從 SSR 而來。
     */
    if (!nuxtApp.isHydrating) return
    if (!authStore.isLogin) return

    /**
     * 因部分 API 需要 auth，而 server side 沒有 auth，故需要在 client side 再次 call API。
     * 但 useAsyncData 在 server side 有資料時，無法在 client side 馬上調用，故需要放在非同步中。
     */
    setTimeout(refresh, 300)
  }

  tryOnMounted(() => {
    refetchDataIfLogin()
  })

  return asyncData
}) as typeof useAsyncData
